/**
 * Base request/response contract helpers shared by api and web
 * (architecture.md §4: "Контракты типизируются в packages/shared — zod-схемы +
 * выводимые TS-типы — и шарятся фронтом и бэком").
 *
 * On the WIRE the new REST API returns the resource data directly on success
 * (HTTP 2xx, no `{ success:true }` / `{ response }` wrapper) and the unified
 * `ApiErrorBody` on failure (HTTP 4xx/5xx). These helpers give both sides one
 * vocabulary for that:
 *
 *   - `apiResponse(dataSchema)`  — builds a zod schema for a success body so a
 *     route can validate its own output and the web client can parse it.
 *   - `ApiResult<T>` / `ok()` / `err()` — a discriminated union the web client
 *     returns after inspecting the HTTP status, so feature code never branches
 *     on raw `fetch` internals and always sees `{ ok:true, data }` or
 *     `{ ok:false, error }` (the unified error). This is where the old
 *     `normalizeN8nPayload()` responsibility now lives, typed.
 */
import { z } from 'zod';
import { apiErrorDetailSchema } from './errors.js';
/**
 * Wrap a data schema as a success-response schema. Today it is the identity of
 * the data schema (data is returned bare on the wire), but routing it through
 * this helper means every contract is declared the same way and a future
 * envelope change happens in exactly one place.
 */
export function apiResponse(dataSchema) {
    return dataSchema;
}
/** A standalone "no content" success body for endpoints that return nothing. */
export const noContentSchema = z.object({}).strict();
/** Construct a success result. */
export function ok(data) {
    return { ok: true, data };
}
/** Construct a failure result from a (already-validated) unified error detail. */
export function err(error) {
    return { ok: false, error };
}
/** Re-export so consumers can build/validate error details alongside results. */
export { apiErrorDetailSchema };
//# sourceMappingURL=contracts.js.map